import "moment/locale/id";
import { Route, Routes } from "react-router-dom";
import Loadable from 'react-loadable';
import PageLoader from "components/PageLoader";

const LazyCategory = Loadable({
    loader: () => import("pages/Category/index"),
    loading: () => <PageLoader />,
});

// const LazyOrderDetail = Loadable({
//     loader: () => import("pages/OrderDetail/index"),
//     loading: () => <PageLoader />,
// });


function CategoryRoute() {
    return (
        <Routes>
            <Route path="/" element={<LazyCategory />} />
            {/* <Route path="/detail/:order_id" element={<LazyOrderDetail />} /> */}
        </Routes>
    );
}

export default CategoryRoute;
